export function formHasErrors(): boolean {
  const errors = document.getElementsByClassName('has-error');
  return errors && errors.length > 0;
}

export function hasAnyControlValue(
  form: { controls: Record<string, { value: unknown }> } | null | undefined,
): boolean {
  return Object.values(form?.controls ?? {}).some(
    control => control.value !== null && control.value !== undefined && control.value !== '',
  );
}

export function validateFormElements(form: string): void {
  const elementsToTrigger: string[] = [
    'input',
    'nx-dropdown',
    'textarea',
    'nx-checkbox',
    'div',
    'span',
  ];
  const blocks = document.getElementById(form);
  if (!blocks) {
    return;
  }
  elementsToTrigger.forEach(element => {
    const inputs: HTMLCollectionOf<Element> = blocks.getElementsByTagName(element);
    for (let j = 0; j < inputs.length; j++) {
      const inputElem = inputs.item(j) as HTMLInputElement;
      if (inputElem.style.display !== 'none') {
        inputElem.focus();
        inputElem.blur();
      }
    }
  });
}
